import { jsBridge } from '@src/utils/js-bridge';
import { makeAutoObservable } from 'mobx';

/** KOL betpick All Betting Strategy 开关 */
class BettingStrategyStore {
    bettingDefault = true;
    /** 通过每个betpick的值来确认是否显示BTN */
    bettingBTNList: boolean[] = [];
    betpickTitleList: boolean[] = [];

    constructor() {
        makeAutoObservable(this);
    }
    setBettingDefault(value: boolean) {
        this.bettingDefault = value;
    }
    setBettingValToApp(value: boolean) {
        this.bettingDefault = value;
        jsBridge.setAllBettingStrategies(value);
    }
    /** 通过每个betpick的值来确认是否显示BTN */
    setBettingBTNList(v: boolean) {
        this.bettingBTNList.push(v);
    }
    setBetpickTitleList(v: boolean) {
        this.betpickTitleList.push(v);
    }
    /** 重置 */
    setResetList() {
        this.bettingBTNList = [];
    }
    setResetBetpickTitleList() {
        this.betpickTitleList = [];
    }

    /** 是否显示All Betting Strategy 按钮 */
    GetbettingBTNList() {
        // console.log('=========bettingBTNList===========', this.bettingBTNList);
        return this.bettingBTNList.includes(true);
    }
    GetBetpickTitleList() {
        // console.log('=========bettingBTNList===========', this.betpickTitleList);
        return this.betpickTitleList.includes(true);
    }
}

const bettingStrategyStore = new BettingStrategyStore();
export default bettingStrategyStore;
